const baseUrl = "https://visitormasterbackend.mhada.gov.in";

export const ApiUrls = {
  login: `${baseUrl}/open/login`,

  otpVerification: `${baseUrl}/open/otp-verification`,

  resendOtp: `${baseUrl}/open/resend-otp`,

  home: `${baseUrl}/secure/home/dashboard`,
  nocDashboard: `${baseUrl}/secure/home/noc-dashboard`,
  assignModerationCasesUrl: `${baseUrl}/secure/home/assign-moderation-cases`,
  moderationList: `${baseUrl}/secure/moderation/list`,
  moderationDetail: `${baseUrl}/secure/moderation/{registrationModerationKey}`,
  findMLPendingDocuments: `${baseUrl}/secure/moderation/ml-pending/{pan}`,
  queryExecutorList: `${baseUrl}/secure/reports/query-exec/list`,
  initQueryExecutorFormUrl: `${baseUrl}/secure/reports/query-exec/form`,
  queryExecutorDetail: `${baseUrl}/secure/reports/query-exec/{queryExecutorKey}`,
  saveQueryExecutor: `${baseUrl}/secure/reports/query-exec`,
  updateQueryExecutor: `${baseUrl}/secure/reports/query-exec/{queryExecutorKey}`,
  toggleActivationQueryExecutorUrl: `${baseUrl}/secure/reports/query-exec/{queryExecutorKey}`,

  proApproverList: `${baseUrl}/secure/pro-approver/list`,
  proApproverDetail: `${baseUrl}/secure/pro-approver/{certJournalistKey}`,
  fetchEsignReceipt: `${baseUrl}/secure/pro-approver/esign-cert/{certJournalistKey}`,

  esignReceipt: `${baseUrl}/secure/verify-esign/{esignType}/{key}`,

  roleList: `${baseUrl}/secure/roles`,
  initRoleFormUrl: `${baseUrl}/secure/roles/form`,
  getRoleByKeyUrl: `${baseUrl}/secure/roles/{roleKey}`,
  saveRole: `${baseUrl}/secure/roles`,
  updateRoleUrl: `${baseUrl}/secure/roles/{roleKey}`,
  toggleActivationRoleUrl: `${baseUrl}/secure/roles/{roleKey}`,

  userList: `${baseUrl}/secure/users`,
  initUserFormUrl: `${baseUrl}/secure/users/form`,
  getUserByKeyUrl: `${baseUrl}/secure/users/{userKey}`,
  saveUser: `${baseUrl}/secure/users`,
  updateUserUrl: `${baseUrl}/secure/users/{userKey}`,
  updateSopMasterUrl: `${baseUrl}/secure/sopMaster/{key}`,
  updateDefaultPasswordUrl: `${baseUrl}/secure/users/default-password`,
  toggleActivationUserUrl: `${baseUrl}/secure/users/{userKey}`,
  deleteSop: `${baseUrl}/secure/sopMaster/{key}`,

  resetUserPasswordUrl: `${baseUrl}/secure/users/reset-password/{userKey}`,
  saveSopMaster: `${baseUrl}/secure/sopMaster`,

  paymentReconSearch: `${baseUrl}/secure/reconciliation/search`,
  paymentReconByTransaction: `${baseUrl}/secure/reconciliation/search/{transactionId}`,
  pendingTransactions: `${baseUrl}/secure/reconciliation/pending-transactions`,

  organizationList: `${baseUrl}/secure/organizations`,
  getOrgByKeyUrl: `${baseUrl}/secure/organizations/{organizationKey}`,
  saveOrg: `${baseUrl}/secure/organizations`,
  updateOrgUrl: `${baseUrl}/secure/organizations/{organizationKey}`,
  activeDactiveOrgUrl: `${baseUrl}/secure/organizations/{organizationKey}`,

  boardList: `${baseUrl}/secure/board`,
  getBoardByKeyUrl: `${baseUrl}/secure/board/{boardKey}`,
  saveBoard: `${baseUrl}/secure/board`,
  initBoardForm: `${baseUrl}/secure/board/form`,
  updateBoardUrl: `${baseUrl}/secure/board/{boardKey}`,
  activeDactiveBoardUrl: `${baseUrl}/secure/board/{boardKey}`,

  featureList: `${baseUrl}/secure/features`,
  initFeatureFormUrl: `${baseUrl}/secure/features/form`,
  getFeatureByKeyUrl: `${baseUrl}/secure/features/{featureKey}`,
  saveFeature: `${baseUrl}/secure/features`,
  updateFeatureUrl: `${baseUrl}/secure/features/{featureKey}`,
  toggleActivationFeatureUrl: `${baseUrl}/secure/features/{featureKey}`,

  importMasterInitFormUrl: `${baseUrl}/secure/import/master/init`,
  importMasterUrl: `${baseUrl}/secure/import/master/{lotteryKey}/{type}`,
  downloadTemplateUrl: `${baseUrl}/secure/import/master/template/{type}`,
  exportAppsInitFormUrl: `${baseUrl}/secure/export-apps`,
  exportPhotosInitFormUrl: `${baseUrl}/secure/export-photos`,
  fetchBatchWiseLotteryPhotosUrl: `${baseUrl}/secure/export-photos/{lotteryKey}`,

  downloadPolUrl: `${baseUrl}/secure/export-pol/{applicationNo}`,

  importResultsInitFormUrl: `${baseUrl}/secure/import-results`,
  exportAppsUrl: `${baseUrl}/secure/export-apps/{lotteryKey}`,
  importResultsUrl: `${baseUrl}/secure/import-results/{lotteryKey}`,
  downloadENCUrl: `${baseUrl}/secure/export-apps/{key}/enc`,
  downloadPhotosUrl: `${baseUrl}/secure/export-photos/{lotteryKey}/{batchName}/{start}/{end}`,
  printExportApplicationsHashCodeUrl: `${baseUrl}/secure/export-apps/{key}/print-hashcode`,

  installmentConfigInitFormUrl: `${baseUrl}/secure/installment-config/init`,
  installmentConfigInitWithLotteryUrl: `${baseUrl}/secure/installment-config/init/{lotteryKey}`,
  installmentConfigSaveWithLotteryUrl: `${baseUrl}/secure/installment-config/save/{lotteryKey}`,
  installmentConfigInitWithSchemeUrl: `${baseUrl}/secure/installment-config/init/{lotteryKey}/{schemeKey}`,
  installmentConfigSaveWithSchemeUrl: `${baseUrl}/secure/installment-config/save/{lotteryKey}/{schemeKey}`,

  reportInitFormUrl: `${baseUrl}/secure/reports/init`,
  generateReportUrl: `${baseUrl}/secure/reports/{selectedReport}`,
  queryExecutorReportUrl: `${baseUrl}/secure/reports/query/{selectedReport}`,

  shiftTenementsInitFormUrl: `${baseUrl}/secure/shift-tenements-bf-data-export/init`,
  fetchShiftTenementStatusForLotteryUrl: `${baseUrl}/secure/shift-tenements-bf-data-export/fetch-shift-tenement-status/{lotteryKey}`,
  shiftTenementForLotteryUrl: `${baseUrl}/secure/shift-tenements-bf-data-export/shift-tenements/{lotteryKey}`,
  approveShiftTenementStatusForLotteryUrl: `${baseUrl}/secure/shift-tenements-bf-data-export/approve-shifted-tenements/{lotteryKey}`,

  // exportAppsInitFormUrl: `${baseUrl}/secure/export-apps`,
  // exportPhotosInitFormUrl: `${baseUrl}/secure/export-photos`,
  // fetchBatchWiseLotteryPhotosUrl: `${baseUrl}/secure/export-photos/{lotteryKey}`,
  // importResultsInitFormUrl: `${baseUrl}/secure/import-results`,
  // exportAppsUrl: `${baseUrl}/secure/export-apps/{lotteryKey}`,
  // importResultsUrl: `${baseUrl}/secure/import-results/{lotteryKey}`,
  // downloadENCUrl: `${baseUrl}/secure/export-apps/{key}/enc`,
  // downloadPhotosUrl: `${baseUrl}/secure/export-photos/{lotteryKey}/{batchName}/{start}/{end}`,
  // printExportApplicationsHashCodeUrl: `${baseUrl}/secure/export-apps/{key}/print-hashcode`,

  menuForLoggedInUserUrl: `${baseUrl}/secure/menu`,
 
  //Update Password
  updatePassword: `${baseUrl}/secure/change-password`,

  //For Announcement
  announcementList: `${baseUrl}/secure/announcement`,
  toggleActivationAnnouncementUrl: `${baseUrl}/secure/announcement/{announcementKey}`,
  saveAnnouncement: `${baseUrl}/secure/announcement`,
  initAnnouncementForm: `${baseUrl}/secure/announcement/form`,
  getAnnouncementByKeyUrl: `${baseUrl}/secure/announcement/{announcementKey}`,
  updateAnnouncementUrl: `${baseUrl}/secure/announcement/{announcementKey}`,

  //k
   getApplicantList: `${baseUrl}/secure/applicant-list/{statusId}/applicantFilterList`,

  fetchAppointmentDetail: `${baseUrl}/secure/applicant-list/{appointmentId}`,

  fetchAppointmentDocFiles: `${baseUrl}/secure/applicant-list/fetchAppointmentDocFiles/{appointmentId}`,

  saveRejectAppointment: `${baseUrl}/secure/applicant-list/saveRejectAppointment/{appointmentId}/{remark}`,

  // saveApproveAppointment: `${baseUrl}/secure/applicant-list/saveApproveAppointment/{appointmentId}/{authorityAdress}/{remark}`,
  saveApproveAppointment: `${baseUrl}/secure/applicant-list/saveApproveAppointment/{appointmentId}/{authorityAdress}`,
  fetchAddress: `${baseUrl}/secure/applicant-list/fetchAddress`,

  fetchBoardList: `${baseUrl}/secure/applicant-list/fetchAllBoardList`,

  fetchAuthorityList: `${baseUrl}/secure/applicant-list/fetchAuthorityList`,

  saveForwardAppointment: `${baseUrl}/secure/applicant-list/saveForwardAppointment/{appointmentId}/{selectedOfficerKey}/{selectedSlotKey}/{remark}`,

  findOpenSlots: `${baseUrl}/secure/applicant-list/findOpenSlots/{selectedOfficerKey}`,

  RescheduleAppointment: `${baseUrl}/secure/applicant-list/saveRescheduledAppointment/{appointmentId}/{selectedSlotKey}/{remark}`,
 
  findOpenSlotsRescheduled: `${baseUrl}/secure/applicant-list/findOpenSlotsRescheduled`,

  eventList: `${baseUrl}/secure/applicant-list/event-list`,

  saveSlotOpening: `${baseUrl}/secure/openSlot/saveSlotOpening`,

  updateSlotOpening: `${baseUrl}/secure/openSlot/{appointmentKey}/updateSlotOpening`,

  toggleActivationAppointmentUrl: `${baseUrl}/secure/openSlot/{appointmentKey}/toggleActivationAppointment`,

  fetchAppointmentDtl: `${baseUrl}/secure/openSlot/fetchAppointmentDtl`,

  getAppointmentByKeyUrl: `${baseUrl}/secure/openSlot/{appointmentKey}`,

  getAuditTrail: `${baseUrl}/secure/document-verification/auditTrail`,

  fetchappointmentPendingCount: `${baseUrl}/secure/AppointmentDashbord/appointmentCountDashboard`,

  fetchappointmentPendingCountToaday: `${baseUrl}/secure/AppointmentDashbord/appointmentCountDashboardCurrentDate`,

  fetchMonthlyApprovedAppointments: `${baseUrl}/secure/AppointmentDashbord/monthlyApprovedAppointments`,

  fetchOtherPersonList: `${baseUrl}/secure/applicant-list/fetchOtherPersonList/{appointmentId}`,

  saveWalkinDetails: `${baseUrl}/secure/applicant-list/saveWalkinDetails`,
  walkinAppointmentListUrl: `${baseUrl}/secure/applicant-list/walkinAppointmentList`,
  walkinAppointmentDownloadGatePassUrl: `${baseUrl}/secure/applicant-list/downloadGatePass/{key}`,

  fetchBoard: `${baseUrl}/secure/applicant-list/fetchAllBoard`,

  // authorityList: `${baseUrl}/secure/applicant-list/apply/{boardKey}/authorityList`,
  authorityList: `${baseUrl}/secure/applicant-list/apply`,

  fetchWalkinDetailsByMobile: `${baseUrl}/secure/applicant-list/fetchWalkinDetailsByMobile`,

 // getForwardedHistory: `${baseUrl}/secure/applicant-list/forwarded-history/{appointmentId}`,

  newfetchappointmentPendingCount: `${baseUrl}/secure/NewAppointmentDashbord/newappointmentCountDashboard`,

  newfetchappointmentPendingCountToaday: `${baseUrl}/secure/NewAppointmentDashbord/newappointmentCountDashboardCurrentDate`,

  newfetchMonthlyApprovedAppointments: `${baseUrl}/secure/NewAppointmentDashbord/newmonthlyApprovedAppointments`,

  getBoards: `${baseUrl}/secure/NewAppointmentDashbord/getBoards`,

  departmentStats: `${baseUrl}/secure/NewAppointmentDashbord/departmentStats`,
  
  todayPendingAppointments: `${baseUrl}/secure/NewAppointmentDashbord/todayPendingAppointments`,

  recentActivities: `${baseUrl}/secure/NewAppointmentDashbord/recentActivities`,

  getBoardStats: `${baseUrl}/secure/NewAppointmentDashbord/boardStats`,
  
  getdepartmentDetails: `${baseUrl}/secure/NewAppointmentDashbord/getDepartmentDetails`,

  getBoardDepartments: `${baseUrl}/secure/NewAppointmentDashbord/getBoardDepartments`,

  getDepartmentPerformance: `${baseUrl}/secure/NewAppointmentDashbord/getDepartmentPerformance`,

  getApplicantLists: `${baseUrl}/secure/NewAppointmentDashbord/{statusId}/applicantFilterLists`,

};
